export default __webpack_public_path__ + "static/media/goopter-ecommerce-retail-store-highlights.9066e436.jpg";